import React, { Component } from 'react';
import { layoutGenerator } from 'react-break'
import { NavLink } from 'react-router-dom'
import Session from '../services/session';


import i from '../imports'
import c from '../components';
import d from '../dialogs';

import { Row, Col, Container, PureGridProvider } from '../3rdparty/react-pure-grid';

//import model from '../model.json'
import header from 'react-icons-kit/fa/header';

const RED = '#FF5563';


const EMPTY_FILTER_VALUE = "empty_filter_value";

const floatingLabelStyle = {
    color: "#BDBDBD"
}


const floatingLabelStyleInForm = {
    color: "#BDBDBD"
}


const underlineStyle = {
    borderColor: "#FF5563"
}

class RequestItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openDialog: false
        }
    }

    handleOpen = () => {
        this.setState({
            openDialog: true
        })
    };

    handleClose = () => {
        this.setState({
            openDialog: false
        })
    };

    render() {
        // let children = this.props.children;
        // let childrenWithProps = React.Children.map(children, child =>
        //     React.cloneElement(child, { openDialog: this.state.openDialog, onClose: this.handleClose }));

        return <Col md={4} style={{ paddingBottom: 30}}>
        <div style={{ height: 320, }}>
            <div style={{ color: '#FF5562' }}>
                <i.Icon size={100} className={'RequestIcon'} icon={this.props.icon} />
            </div>
            <h3 style={{ color: 'White', size: 20, textTransform: 'uppercase' }}>{this.props.header}</h3>
            <div style={{ color: 'White', height: 120, fontWeight: 300, fontSize: 18 }}>
                {this.props.text}
            </div> 
            <br />
        </div>
                <button className='button' onClick={this.handleOpen}>{this.props.button}</button>
            {this.props.dialog(this.state.openDialog, this.handleClose)}
        </Col>
    }
}

class RequestBlock extends Component {

    constructor(props) {
        super(props);
        this.state = {
            calcValues: {
                dateValue: new Date(),
                languageValue: EMPTY_FILTER_VALUE,
                toursNumberValue: 1,
            }
        }
    }

    render() {
        return (
            <PureGridProvider maxWidth={'auto'}>
                <Container style={{ backgroundColor: '#808080' }}>
                    <Container fluid={false}>

                        <Row style={{ margin: 0 }}>
                            <Col >
                                <h1 style={{ color: 'White', size: 20, fontWeight: 500 }}>{i.markdown(Session.model.common.request.main_title)}</h1>
                            </Col>

                            <RequestItem icon={i.faIcons.briefcase}
                                header={Session.model.common.request.title1}
                                text={i.markdown(Session.model.common.request.text1)}
                                button={Session.model.common.request.button1}
                                dialog={(open, handleClose) =>
                                    <d.TourDialog
                                        // onClose={this.handleCloseDialog}
                                        // openDialog={this.state.openDialog}
                                        openDialog={open}
                                        onClose={handleClose}
                                        form_title={Session.model.tours.form_title}
                                        form_description={Session.model.tours.form_description}
                                        calcValues={this.state.calcValues}
                                    />}
                            />

                            <RequestItem icon={i.faIcons.map}
                                header={Session.model.common.request.title2}
                                text={i.markdown(Session.model.common.request.text2)}
                                button={Session.model.common.request.button2}
                                dialog={(open, handleClose) =>
                                    <c.FormDialog
                                        openDialog={open}
                                        onClose={handleClose}
                                        form_title={Session.model.common.request.title2}
                                        form_description={Session.model.common.request.text2}
                                        requestType ='customTourRequest'
                                    >
                                    </c.FormDialog>
                                }
                            />
                            <RequestItem icon={i.faIcons.calendarCheckO}
                                header={Session.model.common.request.title3}
                                text={i.markdown(Session.model.common.request.text3)}
                                button={Session.model.common.request.button3}
                                dialog={(open, handleClose) =>
                                    <d.EventDialog
                                        openDialog={open}
                                        onClose={handleClose}
                                        form_title={Session.model.events.form_title}
                                        form_description={Session.model.events.form_description}
                                        eventsData={Session.model.events.events_data}
                                    />
                                }
                            />
                        </Row>
                    </Container>
                </Container>
            </PureGridProvider>
        );
    }
}

export default RequestBlock;